const ButtonText = ({ icon, title, disabled, className = "", ...rest }) => {
	return (
		<button
			type="button"
			disabled={disabled || false}
			className={`
  				items-center justify-center rounded-lg px-4 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-brand-500
  				transition duration-200
  				${disabled
  				  ? "bg-stone-400 text-brand-100 cursor-not-allowed"
  				  : "text-white bg-gradient-to-r from-brand-500 from-10% via-brand-300 via-30% to-brand-600 to-90% cursor-pointer"
  				}
			`}

			aria-label={title}
			{...rest}
		>
			{/* <span className="w-5 h-5">{icon}</span> */}
			<span className="w-5 h-5">{title}</span>
		</button>
	);
};

export default ButtonText;
